import { RefObject, useCallback, useEffect } from 'react';

export const useClickOutside = <T extends HTMLElement = HTMLDivElement>(
	ref: RefObject<T>,
	fn: () => void | Promise<void>,
) => {
	const handleMouseDown = useCallback(
		(event: globalThis.MouseEvent) => {
			if (ref.current.contains(event.target as Node)) {
				return;
			}

			fn();
		},
		[fn, ref],
	);

	useEffect(() => {
		document.addEventListener('mousedown', handleMouseDown);

		return () => {
			document.removeEventListener('mousedown', handleMouseDown);
		};
	}, [handleMouseDown]);
};
